export enum EIcons {
	menu = 'menu',
	menuOpen = 'menu_open',
	adminPanelSettings = 'admin_panel_settings',
	settings = 'settings',
	queryStats = 'query_stats',
	insertChart = 'insert_chart',
	edit = 'edit',
	delete = 'delete',
	dragIndicator = 'drag_indicator',
	arrowBack = 'arrow_back',
	arrowForward = 'arrow_forward',
	map = 'map',
	directionsCar = 'directions_car',
	logout = 'logout',
	schedule = 'schedule',
	calendarMonth = 'calendar_month',
	skipPrevious = 'skip_previous',
	skipNext = 'skip_next',
	accountCircle = 'account_circle',
	apps = 'apps',
	add = 'add',
	addBox = 'add_box',
	moreVert = 'more_vert',
	barcode = 'barcode',
	variables = 'variables',
	operation = 'operation.svg',
	planning = 'planning.svg',
	drivers = 'drivers.svg',
	personal = 'personal.svg',
	locations = 'locations.svg',
	administration = 'administracion.svg',
	administrationSchedules = 'admin-cronograma.svg',
	administrationHours = 'admin-horarios.svg',
	administrationPersonal = 'admin-personal.svg',
	administrationLocations = 'admin-locaciones.svg',
	shifts = 'turnos.svg',
	units = 'unidades.svg',
	vehicles = 'vehiculos.svg',
	documents = 'documentos.svg',
	cronJobs = 'cron-jobs.svg',
	alerts = 'taxi_alert',
	dod = 'dod.svg',
	flagSolid = 'flag-solid.svg',
	flagRegular = 'flag-regular.svg',
	schedules = 'cronogramas.svg',
	squareCaretLeftSolid = 'square-caret-left-solid.svg',
	squareCaretRightSolid = 'square-caret-right-solid.svg',
	circleUserSolid = 'circle-user-solid.svg',
	rightFromBracketSolid = 'right-from-bracket-solid.svg',
	trashSolid = 'trash-solid.svg',
	trashArrowUpSolid = 'trash-arrow-up-solid.svg',
	squarePlusSolid = 'square-plus-solid.svg',
	circlePlusSolid = 'circle-plus-solid.svg',
	penToSquareSolid = 'pen-to-square-solid.svg',
	xmarkSolid = 'xmark-solid.svg',
	gripVerticalSolid = 'grip-vertical-solid.svg',
	gripSolid = 'grip-solid.svg',
	upRightAndDownLeftFromCenterSolid = 'up-right-and-down-left-from-center-solid.svg',
	arrowLeftSolid = 'arrow-left-solid.svg',
	arrowRightSolid = 'arrow-right-solid.svg',
	chevronRightSolid = 'chevron-right-solid.svg',
	chevronLeftSolid = 'chevron-left-solid.svg',
	ellipsisVerticalSolid = 'ellipsis-vertical-solid.svg',
	filterSolid = 'filter-solid.svg',
	filterCircleXMarkSolid = 'filter-circle-xmark-solid.svg',
	arrowsRotateSolid = 'arrows-rotate-solid.svg',
	arrowsRotateRightSolid = 'arrows-rotate-right-solid.svg',
	arrowsRotateLeftSolid = 'arrows-rotate-left-solid.svg',
	expandMore = 'expand-more.svg',
	calendarRegular = 'calendar-regular.svg',
	userTagSolid = 'user-tag-solid.svg',
	tagSolid = 'tag-solid.svg',
	circleCheckSolid = 'circle-check-solid.svg',
	circleStopSolid = 'circle-stop-solid.svg',
	circleXmarkSolid = 'circle-xmark-solid.svg',
	idCardClipSolid = 'id-card-clip-solid.svg',
	boltSolid = 'bolt-solid.svg',
	roadSolid = 'road-solid.svg',
	sortSolid = 'sort-solid.svg',
	sortUpSolid = 'sort-up-solid.svg',
	sortDownSolid = 'sort-down-solid.svg',
	magnifyingGlassSolid = 'magnifying-glass-solid.svg',
	restWork = 'rest-worked.svg',
	dashboard = 'dashboard',
	dashboards = 'dashboards.svg',
	formatListBulleted = 'format_list_bulleted',
	manageAccounts = 'manage_accounts',
	download = 'download',
	rateReview = 'rate_review',
}

export enum EIconSpace {
	left = 'left',
	right = 'right',
	none = 'none',
}

export enum EIconSize {
	extraLarge = 'extraLarge',
	large = 'large',
	medium = 'medium',
	normal = 'normal',
	small = 'small',
	tiny = 'tiny',
}

export enum EIconButtonSize {
	large = 'large',
	medium = 'medium',
	normal = 'normal',
	small = 'small',
	tiny = 'tiny',
}
